import * as types from '../../action-types';
import {getSingleOfferSummary as initialState } from "../../initialState";

const getSingleOfferSummary = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_OFFER_SUMMARY_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_OFFER_SUMMARY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_OFFER_SUMMARY_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_OFFER_SUMMARY_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleOfferSummary;

